import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { AnalyticalIdContainer, IDButton } from "./AnalyticalId.styled";
import AddEditAnalyticalNote from "../../../AddEditAnalyticalNote/AddEditAnalyticalNote";

const AnalyticalId = (props) => {
  const { t, id, updateRefeshStatus, siteId } = props;
  const [isEditMode, setIsEditMode] = useState(false);
  const [isViewMode, setIsViewMode] = useState(true);
  const [isEditAnalyticalPopupVisible, setIsEditAnalyticalPopupVisible] =
    useState(false);

  const onAnalyticalIdClick = () => {
    setIsEditAnalyticalPopupVisible(true);
  };

  const closeSolutionEditPopup = () => {
    setIsEditMode(false);
    setIsViewMode(true);
    setIsEditAnalyticalPopupVisible(false);
  };

  const togglePopUp = () => {
    setIsEditMode(!isEditMode);
    setIsViewMode(!isViewMode);
  };

  return (
    <AnalyticalIdContainer>
      <IDButton onClick={onAnalyticalIdClick}>{id}</IDButton>
      {isEditAnalyticalPopupVisible && (
        <AddEditAnalyticalNote
          id={id}
          title={t("ANALYTICAL_NOTE")}
          onClose={closeSolutionEditPopup}
          isEditMode={isEditMode}
          isViewMode={isViewMode}
          togglePopUp={togglePopUp}
          updateRefeshStatus={updateRefeshStatus}
          siteId={siteId}
        />
      )}
    </AnalyticalIdContainer>
  );
};

AnalyticalId.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AnalyticalId);
